import couponsServices from "src/api-services/coupons-serives";
import { showResponseMessage } from "src/Components/utils/handellApiResponse";

export const createCouponsSlice = (set, get) => ({
  coupons: [],
  filterCoupons: [],
  coupon: {},
  couponLoading: false,
  couponsLoading: false,
  CouponPagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  },

  fetchCouponsFunction: async () => {
    set({ couponsLoading: true });
    try {
      const response = await couponsServices.getCoupons();
      set({
        coupons: response.data.data.data,
        couponsLoading: false,
        CouponPagination: response.data.data.pagination,
      });
      return response;
    } catch (error) {
      set({ couponsLoading: false });
      return error;
    }
  },

  fetchFilterCouponsFunction: async (data) => {
    set({ couponsLoading: true });
    try {
      const response = await couponsServices.filterCoupons(data);
      set({
        filterCoupons: response.data.data.data,
        couponsLoading: false,
        CouponPagination: response.data.data.pagination,
      });
      return response;
    } catch (error) {
      set({ couponsLoading: false });
      return error;
    }
  },

  fetchCouponFunction: async (id) => {
    set({ couponLoading: true });
    try {
      const response = await couponsServices.getCoupon(id);
      set({ coupon: response.data.data, couponLoading: false });
      return response;
    } catch (error) {
      set({ couponLoading: false });
      return error;
    }
  },

  createCouponFunction: async (data) => {
    set({ couponLoading: true });
    try {
      const res = await showResponseMessage(
        couponsServices.storeCoupon(data),
        "store"
      );
      get().fetchFilterCouponsFunction(1);
      set({
        coupons: [...get().coupons, res.data.data],
        filterCoupons: [...get().filterCoupons, res.data.data],
        couponLoading: false,
      });
      return res;
    } catch (error) {
      set({ couponLoading: false });
      return error;
    }
  },

  updateCouponFunction: async (data) => {
    set({ couponsLoading: true });
    try {
      const res = await showResponseMessage(
        couponsServices.updateCoupon(data),
        "update"
      );

      const newCoupons = get().filterCoupons.map((coupon) =>
        coupon.id === data.id ? res.data.data : coupon
      );

      set({
        coupons: newCoupons,
        filterCoupons: newCoupons,
        couponsLoading: false,
      });
      return res;
    } catch (error) {
      set({ couponsLoading: false });
      return error;
    }
  },

  deleteCouponFunction: async (id) => {
    set({ couponsLoading: true });
    try {
      const res = await showResponseMessage(
        couponsServices.deleteCoupon(id),
        "delete"
      );
      set({
        coupons: get().coupons.filter((coupon) => coupon.id !== id),
        couponsLoading: false,
        filterCoupons: get().filterCoupons.filter((coupon) => coupon.id !== id),
      });
      return res;
    } catch (error) {
      set({ couponsLoading: false });
      return error;
    }
  },
  setCoupon: (coupon) => {
    set({ coupon: coupon });
  },
  setCouponPagination: (pagination) => {
    set({ CouponPagination: pagination });
  },
});
